import { useContent } from '../siteContent';

export function Lifecycle() {
  const { lifecycle } = useContent();
  if (!lifecycle.visible) return null;
  return <section className="mx-lifecycle" aria-labelledby="lifecycle-title">
    <div className="mx-container">
      <header className="mx-section-head mx-section-head-split">
        <h2 id="lifecycle-title" className="mx-h2"><span>{lifecycle.line1}</span><span>{lifecycle.line2}</span></h2>
        <p className="mx-body">{lifecycle.body}</p>
      </header>
      <div className="mx-timeline" role="img" aria-label="مثال لدورة اشتراك: أيام نشطة، ثم تجميد مؤقت، ثم استئناف، فتمتد نهاية الاشتراك بعدد أيام التجميد، ثم تجديد">
        <div className="mx-timeline-bar">
          <span className="seg-active" style={{ flex: 9 }}><b>نشط</b></span>
          <span className="seg-freeze" style={{ flex: 4 }}><b>مجمّد</b></span>
          <span className="seg-active" style={{ flex: 13 }}><b>استئناف</b></span>
          <span className="seg-extend" style={{ flex: 4 }}><b>+ أيام التجميد</b></span>
          <span className="seg-renew" style={{ flex: 6 }}><b>تجديد</b></span>
        </div>
        <div className="mx-timeline-scale"><span>بداية الاشتراك</span><span>النهاية الجديدة</span></div>
      </div>
      <ul className="mx-lifecycle-list">
        {lifecycle.phases.map((phase, index) => <li key={index}><h3>{phase.title}</h3><p>{phase.text}</p></li>)}
      </ul>
      {lifecycle.statement && <p className="mx-statement mx-statement-sm">{lifecycle.statement}</p>}
    </div>
  </section>;
}
